import { render, staticRenderFns } from "./all-costs-table.vue?vue&type=template&id=445b1ca3&scoped=true"
import script from "./all-costs-table.vue?vue&type=script&lang=ts"
export * from "./all-costs-table.vue?vue&type=script&lang=ts"
import style0 from "./all-costs-table.vue?vue&type=style&index=0&id=445b1ca3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445b1ca3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('445b1ca3')) {
      api.createRecord('445b1ca3', component.options)
    } else {
      api.reload('445b1ca3', component.options)
    }
    module.hot.accept("./all-costs-table.vue?vue&type=template&id=445b1ca3&scoped=true", function () {
      api.rerender('445b1ca3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cost-exclusion-step/all-costs-table/all-costs-table.vue"
export default component.exports